// wrapper for the addEllipses utility method, to allow usage as a Vue filter
// see utils/string.js for docs
import { addEllipses } from '@/utils/string';

export default function ellipses(text, maxChars, insertAt, token) {
    return addEllipses({ text, maxChars, insertAt, token });
}
